import { css } from '@styled-system/css'
import styledComponents from 'styled-components'
import { Box, Flex } from 'ui/acro'

// adding the class to this parent element will make it available for the child element grid
export const ToggleContainer = styledComponents(Box)`
${css({
  // prevents scrollbars to appear
  '.infinite-scroll-component': {
    overflow: 'hidden !important'
  },
  '.gap': {
    gap: ['15px', '16px', '22px', '25px'],
    mb: '57px'
  },
  '.list-view': {
    display: 'grid',
    gridTemplateColumns: [
      'repeat(1, 1fr)',
      'repeat(3, 1fr)',
      'repeat(3, 1fr)',
      'repeat(3, 1fr)'
    ],
    // increase the size of the card text when list size is shown
    '.title': {
      // we have to use px instead of em because the body text size is not always 16px.
      fontSize: '16px'
    },
    '.subtitle': {
      fontSize: '14px'
    },
    '.grey-box': {
      minHeight: '194px'
    }
  },
  '.grid-view': {
    display: 'grid',
    gridTemplateColumns: [
      'repeat(2, 1fr)',
      'repeat(3, 1fr)',
      'repeat(3, 1fr)',
      'repeat(3, 1fr)'
    ]
  }
})}`

export const GridToggleBox = styledComponents(Flex)`
${css({
  // only show on mobile
  display: ['flex', 'none', 'none', 'none'],
  alignItems: 'center',
  gap: '11px'
})}`
